import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Logo from './logo.png'; // Optional, remove if no logo file

const theme = createTheme({
  palette: {
    primary: {
      main: '#6534df', // brand color
    },
  },
});

export default function NavBar() {
  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static" color="primary">
        <Toolbar>
          {/* If you don't have logo.png, remove this */}
          <Box
            component="img"
            sx={{ height: 40, marginRight: 2 }}
            src={Logo}
            alt="Company Logo"
          />
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Sparx RiskOS Vendor Consolidation Analysis
          </Typography>
        </Toolbar>
      </AppBar>
    </ThemeProvider>
  );
}